import { IPreloadCacheContext } from 'framework/context/IPreloadCacheContext';
import { IArticlePropertyAutocomplete } from 'gen/ApiClient';
import React from 'react';

export const ArticlePropertiesAutocompleteCacheContext = React.createContext<IPreloadCacheContext<IArticlePropertyAutocomplete[]>>(undefined as any);
